<template>
  <right-layout>
    <div class='body' id="body">
      <!-- 标题 -->
      <div class="headerDiv">
        <div class='bodyContext' style="position: relative;">
          <div class='titile F3-M-27'>ルートを登録</div>
        </div>
      </div>

      <div class="contentDiv slider">
        <div class="req F3-R-14">※ 必須項目</div>
        <!-- 運行区分、アプリ -->
        <div style="display: flex; flex-direction: row;">
          <!-- 運行区分 -->
          <div class='bodyContext info' style="width:50%">
            <div class='label' style="flex:3.7; position: relative;">
              <span class="icon">※</span>
              <div>
                <span>運行区分</span>
              </div>
            </div>
            <div class='context' style="flex:10">
              <div class='radioDiv' style="width:100%; display: flex; align-items: center; line-height: 40px;">
                <label class="radio-inline" style="margin-right: 4%">
                  <input class="radiobutton" type="radio" name="transportKindRadio" v-validate="'required'" v-model="viewModelData.transportKind" value="0">
                  <span></span>
                  <span class="F3-R-20">区域内</span>
                </label>
                <label class="radio-inline">
                  <input class="radiobutton" type="radio" name="transportKindRadio" v-validate="'required'" v-model="viewModelData.transportKind" value="1">
                  <span></span>
                  <span class="F3-R-20">区域外</span>
                </label>
              </div>
            </div>
          </div>
          <!-- ドライバーアプリ端末 -->
          <div class='bodyContext info' style="width:50%">
            <div class='label' style="flex:3.7; position: relative;">
              <!-- <span class="icon">※</span> -->
              <div>
                <span>ドライバーアプリ端末</span>
              </div>
            </div>
            <div class='context' style="flex:10">
              <div class='radioDiv' style="width:100%; display: flex; align-items: center; line-height: 40px;">
                <label class="radio-inline" style="margin-right: 4%">
                  <input class="radiobutton" type="radio" name="driverAppRadio" v-model="viewModelData.routeType" value="1" :disabled="viewModelData.transportKind==0">
                  <span></span>
                  <span class="F3-R-20">使用する</span>
                </label>
                <label class="radio-inline">
                  <input class="radiobutton" type="radio" name="driverAppRadio" v-model="viewModelData.routeType" value="2" :disabled="viewModelData.transportKind==0">
                  <span></span>
                  <span class="F3-R-20">使用しない</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- 運行区分エラーメッセージ -->
        <div class="bodyContext" style="height:25px;" v-show="errors.has('transportKindRadio')" >
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context' style="height:100%;padding-left:10px;">
            <span class="errorMessage">{{ errors.first('transportKindRadio') }}</span>
          </div>
        </div>
        <!-- 路名 -->
        <div class='bodyContext info'>
          <div class='label' style="position: relative;">
            <span class="icon">※</span>
            <div class="">
              <span>ルート名</span>
            </div>
          </div>
          <div class='context'>
            <input v-focus type='text' name='routeName' maxlength="40" v-validate="'required|paintWordNo'" class='inputstyles' v-model="viewModelData.routeName"/>
          </div>
        </div>
        <!-- 账户验证 -->
        <div class="bodyContext" style="height:25px;" v-show="errors.has('routeName')" >
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context' style="height:100%;padding-left:10px;">
            <span class="errorMessage">{{ errors.first('routeName') }}</span>
          </div>
        </div>
        <!-- 出发地 -->
        <div class='bodyContext info router'>
          <div class='label' style="position: relative;">
            <span class="icon">※</span>
            <div>
              <span>出発地</span>
            </div>
          </div>
          <div class='context'>
            <div class="contextColumn1">
              <select class='selectId' style='flex:4' name='startRoute' v-validate="'required'" v-model="startRoute" @change="selectChange(startRoute, 'start')" :disabled="viewModelData.transportKind==''">
                <option :value='item' v-for="(item, index) in stationDataList" :key="index" ref="looks" v-show="item.transportKind == viewModelData.transportKind">
                  {{ item.officeFlag===1?"【事務所】":""}}
                  {{ item.stationName }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- 出发地下拉框验证 -->
        <div class="bodyContext" style="height:25px;" v-show="errors.has('startRoute')">
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context' style="height:100%;padding-left: 10px;">
            <span class="errorMessage">出発地を選択してください。</span>
          </div>
        </div>
        <div class="bodyContext" style="height:25px;" v-show="startRouteDuplicateFlag">
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context' style="height:100%;padding-left: 10px;">
            <span class="errorMessage">同じ停留所を複数回使用することはできません。</span>
          </div>
        </div>

        <!-- 中间路过地址 -->
        <div v-for="(item, index) in passRouteList" :key="index">
          <div class='bodyContext info router' >
            <div class='label'>
              <div>
                <span> 停留所 {{ index + 1}}</span>
              </div>
            </div>

            <div class='context'>
              <div class="contextColumn1">
                <select class='selectId' style='flex:4' :name='`stationid${index}`' v-validate="{required: item.stationId ? checkRoute = false: checkRoute = true}" v-model="item.stationId" @change="selectChange(item, 'passRoute')" :disabled="viewModelData.transportKind==''">
                  <option :value='o.stationId' v-for="(o, i) in stationDataList" :key="i" v-show="(o.transportKind == viewModelData.transportKind) && (o.officeFlag === 0)">{{ o.stationName }}</option>
                </select>
                <div class="clear" @click="delSinglReoute(index)">
                    <div class="clearIcon"></div>
                  </div>
              </div>
            </div>
          </div>

          <div class="bodyContext" style="height:25px;" v-show="errors.has(`stationid${index}`)">
            <div class='label' style="height:100%;background-color: #ffffff;"></div>
            <div class='context' style="height:100%;padding-left: 10px;">
              <span class="errorMessage">停留所を選択してください。</span>
            </div>
          </div>
          <div class="bodyContext" style="height:25px;" v-show="item.isDuplicated">
            <div class='label' style="height:100%;background-color: #ffffff;"></div>
            <div class='context' style="height:100%;padding-left: 10px;">
              <span class="errorMessage">同じ停留所を複数回使用することはできません。</span>
            </div>
          </div>
        </div>

        <!-- 中间的图标div -->
        <div class='bodyContext add'>
          <div @click="addRoute">
            <!-- 圆圈 -->
            <div class='addIcon bgc6' style="cursor:pointer">
              <div style="font-size:2em;color:#fff">+</div>
            </div>
            <!-- 字体 -->
            <div class='addFontSize' style="cursor:pointer">
              <div><p style="margin:auto 0;letter-spacing:5px;font-weight: 600; color:#707070">経由地追加</p></div>
            </div>
          </div>
        </div>

        <!-- 終着地 -->
        <div class='bodyContext info router'>
          <div class='label' style="position: relative;">
            <span class="icon">※</span>
            <div>
              <span>終着地</span>
            </div>
          </div>
          <div class='context'>
            <div class="contextColumn1">
              <select class='selectId' style='flex:4' name='destinationRoute' v-validate="'required'" v-model="destinationRoute" @change="selectChange(destinationRoute, 'destination')" :disabled="viewModelData.transportKind==''">
                <option :value='item' v-for="(item) in stationDataList" :key="item.stationId" v-show="item.transportKind == viewModelData.transportKind">
                  {{ item.officeFlag===1?"【事務所】":""}}
                  {{ item.stationName }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- 终点地下拉框验证 -->
        <div class="bodyContext" style="height:25px;" v-show="errors.has('destinationRoute')" >
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context' style="height:100%;padding-left: 10px;">
            <span class="errorMessage">終着地を選択してください。</span>
          </div>
        </div>
        <div class="bodyContext" style="height:25px;" v-show="destinationRouteDuplicateFlag" >
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context' style="height:100%;padding-left: 10px;">
            <span class="errorMessage">同じ停留所を複数回使用することはできません。</span>
          </div>
        </div>

        <!-- 八一卜距离、八一卜所用时间 -->
        <div style="display: flex; flex-direction: row;">
          <!-- 八一卜距离 -->
          <div class='bodyContext info' style="width:50%">
            <div class='label' style="flex:3.7">
              <div>
                <span>ルート距離</span>
              </div>
            </div>
            <div class='context' style="flex:10">
              <div class='idClass' style="width:100%">
                <div v-show="showInfo">
                  {{ viewModelData.routeDistance | distanceFormatter }}
                </div>
              </div>
            </div>
          </div>
          <!-- 八一卜所用时间 -->
          <div class='bodyContext info' style="width:50%">
            <div class='label' style="flex:3.7">
              <div>
                <span>ルート所要時間</span>
              </div>
            </div>
            <div class='context' style="flex:10">
              <div class='idClass' style="width:100%">
                <div v-show="showInfo">
                  {{ viewModelData.routeTotalTime | timeFormatter }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 地图 -->
        <div class='gooleMap'>
          <google-map ref='gMap' :center-point='centerPoint' :map-id='mapId' :point-list='pointDataList'></google-map>
        </div>
      </div>

      <div class="foot">
        <div>
          <button class="foot-btn footButton clear-btn-border" id="login" data-toggle="modal" href="#modal-container-newLogin" style="cursor:pointer" @click="saveRouter" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
            <span>登録</span>
          </button>
        </div>
        <div>
          <button class="foot-btn footButton clear-btn-border" style="cursor:pointer" @click="$router.go(-1)">
            <span>キャンセル</span>
          </button>
        </div>
      </div>
    </div>

    <v-dialog v-show="showDialogRouter" :dialog-option="dialogOptionRouter" ref="dialogRouter"></v-dialog>
    <new-login-confirm v-if="show"></new-login-confirm>
  </right-layout>
</template>

<script>
import RightLayout from '@/router/layouts/rightLayout'
import googleMap from '@/components/googleMap'
import newLoginConfirm from '@/components/NewLoginConfirm'
import STATION_ICON from '@/assets/map_icon/map_stop_point1.png'
import STATION_ICON_FIRST from '@/assets/map_icon/map_transit_point1.png'
import dialog from '@/components/Dialog'

export default {
  name: 'editRouterInfo',
  components: {
    RightLayout,
    googleMap,
    newLoginConfirm,
    'v-dialog': dialog
  },
  data () {
    return {
      // 验证
      checkRoute: true,
      mapId: 'newRouteMapID',
      // 初始化地图重新点
      // 初始化组件为false
      show: false,
      centerPoint: {
        lat: null,
        lng: null
      },
      // 路的 下拉列表
      stationDataList: [],
      // 保存的数据对象
      viewModelData: {
        routeName: '',
        // 中间地
        routePassPointList: [],
        routeDistance: null,
        routeTotalTime: null,
          // 運行区分
        transportKind: '',
        // ドライバーアプリ端末使用有無 1:使用する 2:使用しない
        routeType: 1,
      },
      num: 0,
      showInfo: false,
      // 开始地
      startRoute: null,
      // 终点地
      destinationRoute: null,

      // 开始地集合.
      startRouteList: [{}],
      // 经过地集合
      passRouteList: [],
      // 终点地集合
      destinationRouteList: [{}],

      // 最终所有坐标点集合 开始 + 经过地 + 终点地
      pointList: [],
      // 地图标记点集合包含图标
      pointDataList: [],
      // 添加或者修改的标识符
      flag: 'add',
      //   弹出框
      showDialogRouter: false,
      dialogOptionRouter: {
        showNo: false,
        text: '事務所だけでルートを登録することはできません。',
        confirmButtonText: '確認'
      },
      duplicateStationIdList: [],
      startRouteDuplicateFlag: false,
      destinationRouteDuplicateFlag: false,
      // ルートに停留所が１つもない時のエラー
      stationCountError: false,
      stationCountErrorMessage: '事務所だけでルートを登録することはできません。<br>事務所以外の停留所を1つ以上含めてください。',
      // ルートに不正な停留所が含まれている時のエラー
      illegalStationError: false,
      illegalStationErrorMessage: '車で移動できない停留所が含まれています。<br>マップ上にルートが表示されるように停留所を選択してください。'
    }
  },
  // 自定义指令
  directives: {
    // 获取焦点
    focus: {
      inserted (el, binding, vnode) {
        el.focus()
      }
    }
  },
  created () {
    this.getAllStationList()
  },
  mounted () {
    this.$refs.gMap.initializeGoogleMap()
  },
  computed: {
  },
  watch: {
    // 监听数组 pointList (数组改变重新获取数据)
    'pointList' (newVal) {
      if (newVal.length > 1) {
        // 是否显示距离 时间信息
        this.showInfo = true
        this.setMarkAndLine(newVal)
      }
    },
    // 運行区分選択が区域内のときはドライバーアプリ端末のチェックを退避する
    'viewModelData.transportKind' (newvalue){
      
      // 停留所選択リセット
      this.startRoute = null
      this.destinationRoute = null
      this.passRouteList.forEach(e => e.stationId = null)
      this.viewModelData.routeDistance = null
      this.viewModelData.routeTotalTime = null
      this.$refs.gMap.initializeGoogleMap()
      this.startRouteList = []
      this.passRouteList = []
      this.destinationRouteList = []
      // this.pointList = []
      
      // if(newvalue == 1){
        this.viewModelData.routeType = 1
      // }
      // }else{
      //   this.viewModelData.routeType = 0
      // }

      // 重複フラグリセット
      this.duplicateStationIdList = []
      this.startRouteDuplicateFlag = false
      this.destinationRouteDuplicateFlag = false
    }
  },
  methods: {
    // 获取停留所信息
    getAllStationList () {
      this.$axios.get('route/getAllStationData').then(res => {
        this.stationDataList = res.data.stationDataList
      }).catch(err => {
        console.log(err)
      })
    },
    // 初始化地图 并且给定图标和路线
    setMarkAndLine (pointList) {
      // 過濾假值
      const arr = pointList.filter(o => {
        if (o.lat && o.lng) return o
      })
      if (arr.length > 1) {
        new Promise((resolve) => {
          let index = 0
          this.pointDataList = []
          for (let i of arr) {
            index += 1
            let p
            if ((index - 1) === 0) p = 'S'
            else if ((index - 1) === (arr.length - 1)) p = 'G'
            else p = `${index - 1}`
            this.pointDataList.push({
              stationId: p,
              stationLng: i.lng,
              stationLat: i.lat,
              icon: p === 'S' ? STATION_ICON_FIRST : STATION_ICON
            })
          }
          resolve()
        }).then(() => {
          this.$refs.gMap.initializeGoogleMap().then(() => {
          // this.$refs.gMap.map.setZoom(14)
          // 绘制路线并且 计算里程和时间
            this.$refs.gMap.plannRoute(arr).then(res => {
              this.illegalStationError = false
              const { totalDistance, totalTime } = res[res.length - 1]
              this.viewModelData.routeTotalTime = totalTime
              this.viewModelData.routeDistance = totalDistance
              // 添加图标 并在 组件中监听事件
              if (this.pointDataList.length !== 0) {
                this.$refs.gMap.pointList = this.pointDataList
                // 添加图标
                let imgSize = {width: 45, height: 60}
                // 图标里面的字体样式
                let labelAnchor = {width: 25, height: 53}
                this.markList = this.$refs.gMap.addMark(imgSize, 'route-label-class', labelAnchor)
              }
            }).catch(err => {
              this.illegalStationError = true
              console.log(err)
            })
          })
        })
      }
    },
    // 添加经过地
    addRoute () {
      // 获取开始和经过地数组
      let startAndPassTotal = this.startRouteList.concat(this.passRouteList)
      // 往经过数组里添加信息
      this.passRouteList.push({ routeNo: startAndPassTotal.length, stationId: null, lat: null, lng: null })
      // 往终了地 routeNo字段 + 1
      if(this.destinationRouteList.length > 0){
        this.destinationRouteList[0].routeNo = startAndPassTotal.length + 1
      }
      // this.pointList = this.viewModelData.routePassPointList = this.startRouteList.concat(this.passRouteList, this.destinationRouteList)
    },
    // 删除单个停留所
    delSinglReoute (index) {
      this.checkRoute = false
      // 去除经由地信息
      this.passRouteList.splice(index, 1)
      // 经由地数组长度大于0
      if (this.passRouteList.length > 0) {
        let startAndPassTotal = this.startRouteList.concat(this.passRouteList)
        // 如果下标是当前数组长度
        if (index === this.passRouteList.length) {
          this.passRouteList[this.passRouteList.length - 1].routeNo = this.passRouteList.length
        } else {
          for (const i of this.passRouteList) {
            if (i.routeNo > index + 1) {
              i.routeNo = i.routeNo - 1
            }
          }
        }
        if(this.destinationRouteList.length > 0){
          this.destinationRouteList[0].routeNo = startAndPassTotal.length
        }
        this.pointList = this.viewModelData.routePassPointList = this.startRouteList.concat(this.passRouteList, this.destinationRouteList)
        this.checkStationDuplicate()
      } else {
        if(this.destinationRouteList.length > 0){
          this.destinationRouteList[0].routeNo = 1
        }

        this.pointList = this.viewModelData.routePassPointList = this.startRouteList.concat(this.destinationRouteList)
        this.checkStationDuplicate()
      }
    },
    // 起始地 经由地和终点地下拉事件
    selectChange (item, route) {
      const { stationId, stationLng, stationLat, officeFlag } = item
      if (route === 'start') {
        // 添加到开始路坐标集合里
        this.startRouteList.splice(0, 1, { routeNo: 0, stationId: stationId, lng: stationLng, lat: stationLat, officeFlag: item.officeFlag })
      } else if (route === 'passRoute') {
        // 匹配停留所id 获取停留所坐标
        let point = { lat: 0, lng: 0, officeFlag: 0}
        for (const x of this.stationDataList) {
          if (item.stationId === x.stationId) {
            point.lng = x.stationLng
            point.lat = x.stationLat
            point.officeFlag = x.officeFlag
            break
          }
        }
        // 过滤掉空选项下拉框
        let arrs = this.passRouteList
        // .filter(o => {
        //   if (o.stationId !== '') return o
        // })
        // 获取当前路由经地的数组下标
        let i
        for (let index = 0; index < arrs.length; index++) {
          const element = arrs[index]
          if (item.stationId === element.stationId) {
            i = index
            break
          }
        }
        this.passRouteList.splice(i, 1, { routeNo: i + 1, stationId: item.stationId, lat: point.lat, lng: point.lng, officeFlag: point.officeFlag })
      } else if (route === 'destination') {
        // 获取开始地和经由地数组 两个数组的长度
        const getStartAndPassRouteList = this.startRouteList.concat(this.passRouteList)

        this.destinationRouteList.splice(0, 1,
          { routeNo: getStartAndPassRouteList.length, stationId: stationId, lng: stationLng, lat: stationLat, officeFlag: item.officeFlag }
        )
      }
      this.pointList = this.viewModelData.routePassPointList = this.startRouteList.concat(this.passRouteList, this.destinationRouteList)
      this.checkStationDuplicate()
    },

    // 重複チェック
    checkStationDuplicate(){
      console.log("checkStationDuplicate")
      console.log(this.pointList)
      // フラグリセット
      this.duplicateStationIdList = []
      this.startRouteDuplicateFlag = false
      this.destinationRouteDuplicateFlag = false
      for(let i = 0; i < this.passRouteList.length; i++){
        this.passRouteList[i].isDuplicated = false
      }
      // 使用されている停留所をループしてIDを比較 重複しているIDを格納
      for(let i = 0; i < this.pointList.length; i++){
        for(let j = 0; j < this.pointList.length; j++){
          if(i!=j){
            if(this.pointList[i].stationId === this.pointList[j].stationId){
              console.log("重複あり")
              this.duplicateStationIdList.push(this.pointList[i].stationId)
            }
          }
        }
      }
      // 重複IDを使ってどこで重複しているかを判定し、エラー表示用フラグを立てる
      for(let i = 0; i < this.duplicateStationIdList.length; i++){
        // 出発地重複チェック
        if(this.duplicateStationIdList[i] == this.startRoute.stationId){
          console.log("出発地重複")
          this.startRouteDuplicateFlag = true
        }
        // 停留所重複チェック
        for(let j = 0; j < this.passRouteList.length; j++){
          if(this.duplicateStationIdList[i] == this.passRouteList[j].stationId){
            console.log("停留所"+ (j+1) + "重複")
            this.passRouteList[j].isDuplicated = true
          }
        }
        // 到着地重複チェック
        if(this.duplicateStationIdList[i] == this.destinationRoute.stationId){
          console.log("到着地重複")
          this.destinationRouteDuplicateFlag = true
        }
      }
    },

    // 停留所存在チェック
    checkStationExist(){
      let stationCount = 0
      this.stationCountError = false
      for(let i = 0; i < this.pointList.length; i++){
        if(this.pointList[i].officeFlag == 0){
          stationCount++
        }
      }
      if(stationCount === 0){
        this.dialogOptionRouter.text = this.stationCountErrorMessage
        this.showDialogRouter = true
        this.stationCountError = true
        this.$refs.dialogRouter.confirm().then(() => {
          this.showDialogRouter = false
        })
      }
    },

    showIllegalStationErrorMessage(){
        this.dialogOptionRouter.text = this.illegalStationErrorMessage
        this.showDialogRouter = true
        this.$refs.dialogRouter.confirm().then(() => {
          this.showDialogRouter = false
        })
    },

    // 保存前确认页面
    saveRouter () {
      this.checkRoute = true
      this.$validator.validateAll().then(result => {
        if (result) {
          // 重複エラーがあるなら中止
          this.checkStationDuplicate()
          if(this.duplicateStationIdList.length === 0){
            // 停留所数エラーがあるなら中止
            this.checkStationExist()
            if(!this.stationCountError){
              // 不正な停留所が含まれていたら中止
              if(!this.illegalStationError){
                if (this.viewModelData.routePassPointList.length >= 2) {
                  this.show = true
                  let arr = []
                  for (const i of this.viewModelData.routePassPointList) {
                    for (const o of this.stationDataList) {
                      if (i.stationId === o.stationId) {
                        arr.push({
                          stationId: o.stationId,
                          stationName: o.stationName
                        })
                      }
                    }
                  }
      
                  let { routeName, routeDistance, routeTotalTime, transportKind, routeType } = this.viewModelData
                  // 展示数据
                  setTimeout(() => {
                    this.$store.commit('SET_LOGININFO', { routeName, routeDistance, routeTotalTime, routePassPointList: arr, flag: this.flag, transportKind, routeType})
                  }, 200)
                  // 提交数据
                  this.$store.commit('SET_LOGININFOS', this.viewModelData)
                } else {
                  // 控制newLoginConfirm子组件显示
                  this.show = false
                }
              }else{
                this.show = false
                this.showIllegalStationErrorMessage()
              }
            }else{
              this.show = false
            }
          }else{
            this.show = false
          }
        } else {
          this.show = false
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.body {
    flex-direction: column;
    margin: 20px 0px;
    // padding: 0 20px;
    height: 100%;
    .headerDiv {
      height: 5%;
    }
    .contentDiv {
      padding: 0px 8%;
      overflow-y: auto;
      height: 75vh;
    }
    .add {
        display: flex;
        justify-content: center;
        align-items: center;
        & > div {
            // border: 1px solid blue;
            width: 230px;
            height: 50px;
            display: flex;
            flex-direction: row;
            & > .addIcon {
              background-color: #c7c8c8;
                margin: 5px;
                width: 40px;
                // border: 1px solid blue;
                border-radius: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            & > .addFontSize {
                margin-left: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                // border: 1px solid blue;
                & > div {
                  // border: 1px solid blue;
                  font-size: 1.5em
                }
            }
        }
    }
    .bodyContext {
        // border: 1px solid blue;
        height: 60px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .titile {
            color: black;
            font-size: 1.5em;
            font-weight: 600; // 字体粗度
        }
        .label {
          display: flex;
          flex: 1.2;
          min-width: 100px;
          height: 100%;
          margin-right: 10px;
          background-color: rgb(218, 225, 230);
          justify-content: center;
          align-items: center;
          & > div > span {
            font-family: 'Noto Sans CJK JP';
            color: rgb(80, 80, 80);
            font-size: 15px;
            font-weight: 400;
          }
        }
        .context {
            display: flex;
            flex: 8;
            width: 100%;
            height: 100%;
            position: relative;
            .contextColumn1 {
              position: relative;
              flex: 1;
              .selectId {
                outline: none;
                padding-left: 15px;
                height: 100%;
                width: 100%;
                text-indent: 1px;
                border-radius: 10px;
                // margin: 0px -15px 5px 0px;
                -moz-appearance: none;
                -webkit-appearance: none;
                background: url('../../assets/dropselect.png') no-repeat scroll
                    right center transparent;
              }
              .clear {
                position: absolute;
                width: 20px;
                height: 20px;
                top: 15px;
                right: 30px;
                background-color: #8f908b;
                border-radius: 50%;
                display: flex;
                justify-content:center;
                align-items:Center;
                cursor: pointer;
                .clearIcon {
                  background-color: white;
                  width: 13px;
                  height: 2px;
                }
              }
            }
        }
    }
    .info {
        padding: 5px 10px;
    }
    .foot {
      height: 100px;
      width: 80%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      & > div {
        width: 100%;
        padding: 0 60px;
      }
      .foot-btn {
        height: 50px;
        border-radius: 10px;
        background-color: #707070;
        line-height: 50px;
        text-align: center;
        width: 100%;
        & > span {
          color: white;
          font-size: 1.6em;
          font-weight: 300; // 字体粗度
        }
      }
    }
}
.T7-radius {
    width: 80%;
    max-width: 200px;
    height: 48px;
    background: rgb(109, 109, 109);
    border-radius: 30px;
    color: #ffffff;
    text-align: center;
    font-size: 17px;
    padding: 0;
    border: solid 1px;
    margin-left: 10px;
}
.inputstyles {
    width: 100%;
    height: 100%;
    line-height: 20px;
    padding-left: 10px;
    text-align: left;
}
.idClass {
    height: 100%;
    width: 45%;
    // border: 1px solid black;
    background-color: #f0f0f0;
    & > div {
        font-size: 26px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        padding-left: 10px;
        padding-top: 5px;
    }
}
.gooleMap {
  width: 99%;
  height: 500px;
  margin: 0 10px;
}
#newRouteMapID {
  width: 100%;
  height: 100%;
}
.req {
  text-align: left;
  // 文字缩进
  text-indent: 3em;
}
.icon {
  left: 10px;
  position: absolute;
  color :black;
    font-size: 1.6em;
}

.accountStyle {
  width: 100%;
  border: 1px solid red;
  height: 25px;
  display: flex;
  flex-direction: row;
}
.errorMessage {
  color: red;
}
.inputstyles, select {
  font-weight: 500px;
  font-size: 1.5em;
}
.radiodiv {
  border-radius: 10px;
  width: 300px;
  height: 45px;
  margin-top: 5px;
  text-align: center;
  font-size: 18px;
}
.radiobutton {
  height: 30px;
  width: 30px;
}
input[type="radio"] + span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/router/views/NewRouteLogin.vue